import React, { FC } from 'react'
import Head from 'next/head'
import { slugs } from '@/constants/slugs'
import { ServerExperiments } from '@/experimentation'
import { PhaseSlugForTracking } from '@/services/ProjectPhaseService'
import { ShopifyProductWithBundles } from '@/services/Shopify/ShopifyService'
import { SweepstakeObject } from '@/types/codegen-federation'
import { GiveawayLayout } from './GiveawayLayout'
import { GiveawayContextProvider } from './context/GiveawayContext'
import { GiveawayTypographyProvider } from './context/GiveawayTypographyProvider'
import { useGiveawayConfigData } from './hooks/useGiveawayConfigData'

export const vacationSlugs = new Set([slugs.braveTheDark, slugs.ruleBreakers])

interface Props {
  theatricalSlug: string
  tickets: ShopifyProductWithBundles[] | null
  sweepstake: SweepstakeObject
  phase: PhaseSlugForTracking
  experiments?: ServerExperiments
  releaseDate: string | null
}

export const PreSalesGiveawayView: FC<Props> = ({
  tickets,
  theatricalSlug,
  phase,
  sweepstake,
  experiments,
  releaseDate,
}) => {
  const giveawayData = useGiveawayConfigData({ theatricalSlug })

  if (!giveawayData) return null

  return (
    <>
      <Head>
        <link
          rel="preload"
          href="https://images.angelstudios.com/raw/upload/v1750703334/angel-studios/fonts/woff2/compactacom-regular-webfont.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
      </Head>
      <GiveawayTypographyProvider theatricalSlug={theatricalSlug}>
        <GiveawayContextProvider
          theatricalSlug={theatricalSlug}
          tickets={tickets}
          sweepstake={sweepstake}
          phase={phase}
          giveawayData={giveawayData}
          experiments={experiments}
          releaseDate={releaseDate}
        >
          <GiveawayLayout />
        </GiveawayContextProvider>
      </GiveawayTypographyProvider>
    </>
  )
}
